import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import type { LibraryItem } from '../../api/types';
import MediaCard from './MediaCard';

/// A shelf. The tiles size themselves, so the same grid works on a phone and on a television.
export default function MediaGrid({ items, emptyKey }: { items: LibraryItem[]; emptyKey: string }) {
  const { t } = useTranslation();

  if (items.length === 0) {
    return <Typography color="text.secondary">{t(emptyKey)}</Typography>;
  }

  return (
    <Box
      sx={{
        display: 'grid',
        gap: 2.5,
        gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
      }}
    >
      {items.map((item) => (
        <MediaCard key={item.id} item={item} />
      ))}
    </Box>
  );
}
